import { useEffect } from 'react';
import Component from '../components/common/Component';
import { useHelmetData } from '../contexts/Contexts';

export default function Experience(props) {
   const context = useHelmetData()
   useEffect(() => { 
      context.setSeoTitle(props.title)
      context.setSeoDescription(props.description)
   }, [context, props])
  return(
		<>
      <Component component='heroSection' from='experience'/>
      <Component component='services'/>
      <Component component='verticals'/>
      <Component component='testimonials'/> 
      <Component component='caseStudies'/>
      <Component component='footer'/>  
		</>
	)
}